import { ICopyable } from '../controls/common/icopyable';
import { IArticleAlias } from './interfaces/article-alias.interface';

export class ArticleAlias implements ICopyable<ArticleAlias> {
    public id: number = null;
    public articleId: number = null;
    public alias: string = null;
    public customerId: number = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): ArticleAlias {
        const instance = new ArticleAlias();
        instance.id = this.id;
        instance.articleId = this.articleId;
        instance.alias = this.alias;
        instance.customerId = this.customerId;

        return instance;
    }

    public static createFormCopy(articleAlias: ArticleAlias): IArticleAlias {
        const instance = new ArticleAlias();
        instance.id = articleAlias.id;
        instance.articleId = articleAlias.articleId;
        instance.alias = articleAlias.alias;
        instance.customerId = articleAlias.customerId;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.articleId = other.articleId;
        this.alias = other.alias;
        this.customerId = other.customerId;
    }

    public getDisplayName() {
        return `${this.alias}`;
    }
}
